import React, { memo } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import "./basics.css";

const SelectCustom = ({
  optionsList = [],
  mask = null,
  size = "small",
  value = null,
  keyObject = "descricao",
  setValue = () => {},
  required = false,
  error,
  getOptionSelected = (option, value) =>
    option ? option.Id === value.Id : null,
  onChange = (value) => {
    setValue(value);
  },
  loading = false,
  ...props
}) => {
  return (
    <Autocomplete
      options={optionsList}
      value={value}
      size={size}
      loading={loading}
      onChange={(event, newValue) => {
        onChange(newValue);
      }}
      getOptionSelected={getOptionSelected}
      getOptionLabel={(option) => {
        return option ? option[keyObject] : "";
      }}
      style={{ width: "100%" }}
      {...props}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          error={!!error}
          label={props.label}
          className="filter-input"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default memo(SelectCustom);
